import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';

interface TablePageLayoutProps {
  loading: boolean;
  error: string | null;
  errorPrefix?: string;
  children: React.ReactNode;
}

/**
 * Layout wrapper for table pages. Handles loading spinner, error alert, and page container.
 */
const TablePageLayout: React.FC<TablePageLayoutProps> = ({
  loading,
  error,
  errorPrefix = 'Error:',
  children,
}) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3 }}>
        {errorPrefix} {error}
      </Alert>
    );
  }

  return (
    <Box sx={{
      px: { xs: 1, sm: 2, md: 3 },
      maxWidth: '100vw',
      boxSizing: 'border-box',
      overflow: 'visible',
    }}>
      {children}
    </Box>
  );
};

export default TablePageLayout;
